export const REQUEST_MY_SUCCESS: 'MY_SUCCESS/REQUEST' = 'MY_SUCCESS/REQUEST';
export const MY_SUCCESS_LOADING: 'MY_SUCCESS/LOADING' = 'MY_SUCCESS/LOADING';
export const RECEIVED_MY_SUCCESS_ITEMS: 'MY_SUCCESS/RECEIVED_ITEMS' = 'MY_SUCCESS/RECEIVED_ITEMS';
export const REQUEST_MY_SUCCESS_LEVELS: 'MY_SUCCESS/REQUEST_SUCCESS_LEVELS' = 'MY_SUCCESS/REQUEST_SUCCESS_LEVELS';
export const RECEIVED_MY_SUCCESS_LEVELS: 'MY_SUCCESS/RECEIVED_SUCCESS_LEVELS' = 'MY_SUCCESS/RECEIVED_SUCCESS_LEVELS';
